import React, { Component, PropTypes } from 'react';
import connect from '../../utils/connect';

import translate from '../../utils/translate';

class ErrorPage extends Component {
	static propTypes = {};

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<article className='page'>
				<section className='page__description'>
					<h1 className='page__head'>{translate('error404/title')}</h1>
					<p className='page__excerpt span8'>{translate('error404/text')}</p>
				</section>
			</article>
		);
	}
}

export default connect(ErrorPage);



/** WEBPACK FOOTER **
 ** ./frontend/containers/errorPage/errorPage.js
 **/